import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Menu, Alert } from "antd";
import { logoutUser } from "Features/Auth/apis/logoutUser";
import { useUserInfo } from "GlobalStates/User";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Constants/AllRoutes";
import { PageLinks } from "./pageLinks";
import clsx from "clsx";
import { Flex } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import "./styles.css";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLoginWithLinkedin } from "Features/Auth/hooks/useLoginWithLinkedin";
import LoginModal from "./LoginModal";

export const Navbar = ({ collapsed, setCollapsed, isScrolled }) => {
  const [loginModal, setLoginModal] = useState(false);
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [selectedKey, setSelectedKey] = useState("1");
  const location = useLocation();
  const { user, setUser } = useUserInfo();
  const navigate = useNavigate();
  const login = useLoginWithLinkedin();
  const logoutUserMutation = useMutation({
    mutationFn: logoutUser,
    onSuccess: () => {
      setTimeout(() => {
        setUser(() => ({
          token: "",
          name: "",
          role: "",
          hasCompletedProfile: false,
          isVerified: false,
          picture: "",
        }));
        navigate("/", { state: { justLoggedOut: true } });
      }, 2000);
    },
  });

  const handleMenuClick = (e) => {
    const { target } = PageLinks.find((item) => item.key === e.key) || {};
    if (target) navigate(target);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchingLink = PageLinks.find((link) => link.target === currentPath);
    if (matchingLink) {
      setSelectedKey(matchingLink.key);
    } else {
      // Default to home if no match found
      setSelectedKey("1");
    }
  }, [location.pathname]);

  if (!user?.token) {
    return (
      <div className={clsx("navbar-main-container", isScrolled && "scrolled")}>
        <div className="navbar-logo-container">
          <img
            src={
              "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
            }
            alt="logo"
            className="navbar-main-logo"
            onClick={() => navigate(ROUTES.HOME)}
          />
        </div>

        <div className="desktop-menu">
          <Menu
            mode="horizontal"
            selectedKeys={[selectedKey]}
            items={PageLinks.map((link) => ({
              key: link.key,
              label: link.label,
            }))}
            className="navbar-menu"
            onClick={handleMenuClick}
            style={{ border: "none", flex: 3 }}
          />
          <div className="button-group">
            <button
              className="signup-button"
              onClick={() => {
                setLoginModal(true);
              }}
            >
              Login
            </button>
            <button
              className="signup-button"
              onClick={() => {
                setLoginModal(true);
              }}
            >
              Sign Up
            </button>
          </div>
        </div>

        <div
          className="hamburger-icon"
          onClick={() => setIsMobileMenuVisible(true)}
        >
          <MenuOutlined />
        </div>

        {isMobileMenuVisible && (
          <div className="mobile-menu-overlay">
            <Flex
              align="center"
              justify="space-between"
              className="mobile-menu-header"
            >
              <div className="navbar-logo-container mobile-menu-logo">
                <img
                  src={
                    "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
                  }
                  alt="logo"
                  className="navbar-main-logo"
                  onClick={() => navigate(ROUTES.HOME)}
                />
              </div>
              <button
                className="close-button"
                onClick={() => setIsMobileMenuVisible(false)}
              >
                <CloseOutlined />
              </button>
            </Flex>

            <Menu
              mode="vertical"
              selectedKeys={[selectedKey]}
              className="mobile-nav-links"
              onClick={(e) => {
                if (e.key === "signup") {
                  navigate(ROUTES.COLLEGE_FINDER);
                } else {
                  handleMenuClick(e);
                }
                setIsMobileMenuVisible(false);
              }}
              items={[
                ...PageLinks.map((link) => ({
                  key: link.key,
                  label: link.label,
                })),
              ]}
            />
            <div className="mobile-button-group">
              <button
                className="signup-button mobile-login-button"
                onClick={() => {
                  setLoginModal(true);
                }}
              >
                Login
              </button>
              <button
                className="signup-button mobile-login-button"
                onClick={() => {
                  setLoginModal(true);
                }}
              >
                Sign Up
              </button>
            </div>
          </div>
        )}

        <LoginModal
          open={loginModal}
          onClose={() => setLoginModal(false)}
          onGoogleLogin={() => {}}
          onLinkedInLogin={() => {
            login();
          }}
        />
      </div>
    );
  }

  return (
    user?.token &&
    user?.hasCompletedProfile && (
      <>
        <Menu
          className="navbar-logged-in-menu"
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={["1"]}
          items={[
            {
              key: "0",
              className: "sidebar-control",
              icon: collapsed ? (
                <MenuUnfoldOutlined style={{ fontSize: "20px" }} />
              ) : (
                <MenuFoldOutlined style={{ fontSize: "20px" }} />
              ),
            },
            {
              key: "1",
              className: "logout-menu",
              icon: (
                <img
                  src={user?.picture}
                  className="user-icon"
                  alt="user"
                  width={40}
                  referrerPolicy="no-referrer"
                />
              ),
              children: [
                {
                  key: "1-1",
                  label: "Logout",
                },
              ],
            },
          ]}
          onClick={(e) => {
            if (e.key === "0") {
              setCollapsed(!collapsed);
            }
            if (e.key === "1-1") {
              logoutUserMutation.mutate();
            }
          }}
          style={{
            border: "none",
          }}
        ></Menu>
        {!user?.isVerified && (
          <Alert
            message="Your profile is pending verification. You can manage your appointments in the mean time"
            type="warning"
            banner
            style={{ maxWidth: "99%", margin: "0.5em", fontWeight: "500" }}
          />
        )}
      </>
    )
  );
};
